import * as moment from 'moment';
import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { QueryParameters } from '../../analytics-core/interfaces/query-parameters.interface';
import { DATEPICKER } from '../constants/analytics.constants';
import { AnalyticsDataModel } from '../models/analytics.datamodel';
import { AnalyticsService } from '../services/analytics.service';

@Injectable()
export class CanActivateAnalyticsGuard implements CanActivate {
	constructor(
		private router: Router,
		private analyticsService: AnalyticsService,
		private analyticsDataModel: AnalyticsDataModel
	) {}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		return new Promise((resolve) => {
			this.analyticsService.getSetupData().subscribe((response: any) => {
				if (response.success) {
					this.analyticsDataModel.data = response;
					this.analyticsService.getPartnerConfiguration().subscribe((res: any) => {
						this.analyticsService.getPartnerConfigFromDefaultConfig(res).subscribe((res2: any) => {
							this.analyticsDataModel.setFinalConfig(res, res2);
							const queryParamsObject: QueryParameters = this.analyticsDataModel.getQueryParamsObj();
							const datesSelected = this.analyticsService.processQueryParamsDateRanges(queryParamsObject);
							queryParamsObject.start_date = datesSelected.startDate;
							queryParamsObject.end_date = datesSelected.endDate;
							if (this.analyticsDataModel.getSelectedAdvertiserIds().length > 0) {
								this.analyticsService
									.getCampaignData(this.analyticsDataModel.getSelectedAdvertiserIds())
									.subscribe((r: any) => {
										this.analyticsDataModel.campaigns = r.campaigns;
										this.analyticsDataModel.campaignsData = r.campaigns;
										this.analyticsDataModel.selectedCampaigns = this.analyticsDataModel.campaigns.filter(
											(obj) => obj.selected
										);
										this.analyticsDataModel.startDate = datesSelected.startDate;
										this.analyticsDataModel.endDate = datesSelected.endDate;
										resolve(true);
									});
							} else {
								this.analyticsDataModel.startDate = datesSelected.startDate;
								this.analyticsDataModel.endDate = datesSelected.endDate;
								resolve(true);
							}
						});
					});
				} else {
					this.router.navigate(['/login']);
					resolve(false);
				}
			});
		});
	}
}
